<ng-container *ngIf="state$ | async as state">
    <div>
        <ng-container *ngFor="let value of facet.values | slice: 0 : state.topVisible">
            <a #facetValue routerLink="./" [queryParams]="getLinkParams(value)" class="value"
                [class.selected]="value.selected" [cxFocus]="{ key: value.name }" (keydown)="onKeydown($event)"
                (keydown.space)="openLink($any($event))" [attr.role]="facet.multiSelect ? 'checkbox' : null"
                [attr.aria-checked]="facet.multiSelect ? value.selected : null" attr.aria-label="{{
        'productFacetNavigation.ariaLabelItemsAvailable'
          | cxTranslate: { name: value.name, count: value.count }
      }}" [class]="getFacetValueClass(value)" *ngIf="!isReadOnly(value); else readOnly">
                <span aria-hidden="true">{{ value.name
                    }}<span aria-hidden="true" class="count">{{ value.count }}</span></span>
            </a>

          <ng-template #readOnly>
            <a [class]="'value selected readonly' + ' ' + getFacetValueClass(value)">
                    <span aria-hidden="true">{{ value.name
                      }}<span aria-hidden="true" class="count">{{ value.count }}</span></span>
            </a>
          </ng-template>
        </ng-container>

        <div class="more">
          <ng-container *ngFor="let value of facet.values | slice: state.topVisible ?? 0 : state.maxVisible">
            <a #facetValue routerLink="./" [queryParams]="getLinkParams(value)" class="value"
                [class.selected]="value.selected" [cxFocus]="{ key: value.name }" (keydown)="onKeydown($event)"
                (keydown.space)="openLink($any($event))"[attr.role]="facet.multiSelect ? 'checkbox' : null"
               [attr.aria-checked]="facet.multiSelect ? value.selected : null" attr.aria-label="{{
        'productFacetNavigation.ariaLabelItemsAvailable'
          | cxTranslate: { name: value.name, count: value.count }
      }}" [class]="getFacetValueClass(value)" *ngIf="!isReadOnly(value); else readOnly">
                <span aria-hidden="true">{{ value.name
                  }}<span aria-hidden="true" class="count">{{ value.count }}</span></span>
            </a>
            <ng-template #readOnly>
              <a [class]="'value selected readonly' + ' ' + getFacetValueClass(value)">
                    <span aria-hidden="true">{{ value.name
                      }}<span aria-hidden="true" class="count">{{ value.count }}</span></span>
              </a>
            </ng-template>
          </ng-container>

            <button *ngIf="
          state.maxVisible &&
          state.topVisible &&
          state.maxVisible > state.topVisible
        " (click)="decreaseVisibleValues()" [cxAtMessage]="
          'productFacetNavigation.decreaseOptionsVisibility' | cxTranslate
        " aria-expanded="true" attr.aria-label="{{
          'productFacetNavigation.ariaLabelShowLess' | cxTranslate
        }}" class="cx-action-link" [cxFocus]="{ key: 'moreorless' }">
                {{ 'productList.showLess' | cxTranslate }}
            </button>

            <button *ngIf="
          state.maxVisible &&
          facet.values &&
          state.maxVisible > 0 &&
          state.maxVisible < facet.values.length
        " (click)="increaseVisibleValues()" [cxAtMessage]="
          'productFacetNavigation.increaseOptionsVisibility' | cxTranslate
        " aria-expanded="false" attr.aria-label="{{
          'productFacetNavigation.ariaLabelShowMore' | cxTranslate
        }}" class="cx-action-link" [cxFocus]="{ key: 'moreorless' }">
                {{ 'productList.showMore' | cxTranslate }}
            </button>
        </div>
    </div>
</ng-container>
